const ListIcon = ({ width = 17, height = 19, color = '#000000' }) => {
  return (
    <svg
      width={`${width}px`}
      height={`${height}px`}
      viewBox={`0 0 ${width} ${height}`}
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <title>List View</title>
      <defs>
        <path
          d='M3.95833333,13.4583333 C5.27000961,13.4583333 6.33333333,14.5216571 6.33333333,15.8333333 C6.33333333,17.1450096 5.27000961,18.2083333 3.95833333,18.2083333 C2.64665705,18.2083333 1.58333333,17.1450096 1.58333333,15.8333333 C1.58333333,14.5216571 2.64665705,13.4583333 3.95833333,13.4583333 Z M3.95833333,15.0416667 C3.52110791,15.0416667 3.16666667,15.3961079 3.16666667,15.8333333 C3.16666667,16.2705588 3.52110791,16.625 3.95833333,16.625 C4.39555876,16.625 4.75,16.2705588 4.75,15.8333333 C4.75,15.3961079 4.39555876,15.0416667 3.95833333,15.0416667 Z M16.625,15.0416667 C17.0622254,15.0416667 17.4166667,15.3961079 17.4166667,15.8333333 C17.4166667,16.2705588 17.0622254,16.625 16.625,16.625 L16.625,16.625 L8.70833333,16.625 C8.27110791,16.625 7.91666667,16.2705588 7.91666667,15.8333333 C7.91666667,15.3961079 8.27110791,15.0416667 8.70833333,15.0416667 L8.70833333,15.0416667 Z M3.95833333,7.125 C5.27000961,7.125 6.33333333,8.18832372 6.33333333,9.5 C6.33333333,10.8116763 5.27000961,11.875 3.95833333,11.875 C2.64665705,11.875 1.58333333,10.8116763 1.58333333,9.5 C1.58333333,8.18832372 2.64665705,7.125 3.95833333,7.125 Z M3.95833333,8.70833333 C3.52110791,8.70833333 3.16666667,9.06277457 3.16666667,9.5 C3.16666667,9.93722543 3.52110791,10.2916667 3.95833333,10.2916667 C4.39555876,10.2916667 4.75,9.93722543 4.75,9.5 C4.75,9.06277457 4.39555876,8.70833333 3.95833333,8.70833333 Z M16.625,8.70833333 C17.0622254,8.70833333 17.4166667,9.06277457 17.4166667,9.5 C17.4166667,9.93722543 17.0622254,10.2916667 16.625,10.2916667 L16.625,10.2916667 L8.70833333,10.2916667 C8.27110791,10.2916667 7.91666667,9.93722543 7.91666667,9.5 C7.91666667,9.06277457 8.27110791,8.70833333 8.70833333,8.70833333 L8.70833333,8.70833333 Z M3.95833333,0.791666667 C5.27000961,0.791666667 6.33333333,1.85499039 6.33333333,3.16666667 C6.33333333,4.47834295 5.27000961,5.54166667 3.95833333,5.54166667 C2.64665705,5.54166667 1.58333333,4.47834295 1.58333333,3.16666667 C1.58333333,1.85499039 2.64665705,0.791666667 3.95833333,0.791666667 Z M3.95833333,2.375 C3.52110791,2.375 3.16666667,2.72944124 3.16666667,3.16666667 C3.16666667,3.60389209 3.52110791,3.95833333 3.95833333,3.95833333 C4.39555876,3.95833333 4.75,3.60389209 4.75,3.16666667 C4.75,2.72944124 4.39555876,2.375 3.95833333,2.375 Z M16.625,2.375 C17.0622254,2.375 17.4166667,2.72944124 17.4166667,3.16666667 C17.4166667,3.60389209 17.0622254,3.95833333 16.625,3.95833333 L16.625,3.95833333 L8.70833333,3.95833333 C8.27110791,3.95833333 7.91666667,3.60389209 7.91666667,3.16666667 C7.91666667,2.72944124 8.27110791,2.375 8.70833333,2.375 L8.70833333,2.375 Z'
          id='path-1'
        ></path>
      </defs>
      <g
        id='Symbols'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
      >
        <g
          id='Main/My-Media-Title/List-View'
          transform='translate(-1.000000, 0.000000)'
        >
          <g id='Group-2'>
            <g id='icons/glyphs/list'>
              <g id='ic_list'>
                <mask id='mask-2' fill='white'>
                  <use xlinkHref='#path-1'></use>
                </mask>
                <g id='Combined-Shape' fillRule='nonzero'></g>
                <g
                  id='general/palette/neutral/grey-dark-1'
                  mask='url(#mask-2)'
                  fill={color}
                  fillOpacity='0.8'
                >
                  <g
                    transform='translate(-3.958333, -3.958333)'
                    id='palette/secondary'
                  >
                    <rect
                      x='0'
                      y='0'
                      width='26.9166667'
                      height='26.9166667'
                    ></rect>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default ListIcon;
